import * as React from "react";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent/DataBaseComponent";
import DateRangePicker, {DateRange} from "./DateRangePicker";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import moment from "moment";

interface DateRangePickerDialogProps {
    startDate: moment.Moment;
    endDate: moment.Moment;
    onChange?(range: DateRange): void;
    onSaveDone?(range: DateRange): void;
}

interface DateRangePickerDialogState extends DataBaseComponentState {
    range: DateRange;
}

export default class DateRangePickerDialog extends DataBaseComponent<DateRangePickerDialogProps, DateRangePickerDialogState> {
    constructor(props: DateRangePickerDialogProps) {
        super(props);
        this.state = {
            range: {
                startDate: props.startDate.clone(),
                endDate: props.endDate.clone(),
            }
        };
    }

    render() {
        return (
            <SaveDialogLayout title="Date Range"
                              busy={this.state.busy}
                              errors={this.state.errors}
                              onSaveClick={() => this.save()}>
                <DateRangePicker
                    startDate={this.state.range.startDate}
                    endDate={this.state.range.endDate}
                    onChange={range => {
                        this.setState({range});
                        if (this.props.onChange) {
                            this.props.onChange(range);
                        }
                    }}
                />
            </SaveDialogLayout>
        );
    }

    private async save() {
        if (this.props.onSaveDone) {
            this.props.onSaveDone(this.state.range);
        }
        return true;
    }
}
